import { render } from "./LoanDetailsView.vue?vue&type=template&id=4d9d43c2&scoped=true"
import script from "./LoanDetailsView.vue?vue&type=script&lang=js"
export * from "./LoanDetailsView.vue?vue&type=script&lang=js"

import "./LoanDetailsView.vue?vue&type=style&index=0&id=4d9d43c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9d43c2"]])

export default __exports__